var map = {
	"./ecg-detail-back-1.png": "3216",
	"./ecg-detail-back-2.png": "a5c2",
	"./ecg-detail-back-3.png": "3ef9",
	"./ecg-detail-back-4.png": "0686",
	"./ecg-detail-back-banner1.png": "5d0e",
	"./ecg-detail-back-banner2.png": "c738",
	"./ecg-detail-back-banner3.png": "9061",
	"./ecg-detail-back-banner4.png": "8dcd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "558b";